import { EntityInput, LinkProps } from "helpers/url";
import { UrlObject } from "url";

export function promoHref(entity: EntityInput): LinkProps["href"] {
  return {
    pathname: "/promo/[alias]",
    query: {
      alias: entity.alias,
    },
  } as Partial<UrlObject>;
}

export function promoAs(entity: EntityInput): LinkProps["as"] {
  return `/promo/${entity.alias}/`;
}
